import { isNil } from 'ramda';

import { convertInfrastructureToFeature } from './convertInfrastructureToFeature';
import { InfrastructureType } from '../../../store/map';
import { TIOSMInfrastructure } from '../../../types';
import { getInfrastructureType } from '../../../utils/map';
import { IconCurrentVillage } from '../icons';

export interface IInfrastructureObject {
  type: 'Feature';
  id: string;
  infrastructureType: InfrastructureType;
  geometry: {
    coordinates: [number, number];
    type: 'Point';
  };
  options: {
    balloonLayout: Function;
    iconLayout: Function | null;
    iconOffset: [number, number];
    iconShape: {
      coordinates: [number, number];
      radius: number;
      type: 'Circle';
    };
    iconSize: [number, number];
    zIndex: number;
  };
  properties: {
    objects: {
      name: string;
      type: number;
    }[];
  };
}

export function convertInfrastructureListToFeatureList(ymaps: YMaps.IYMaps, list: TIOSMInfrastructure[]) {
  return list.reduce((acc, item) => {
    const featureType = item.type ? getInfrastructureType(item.type) : undefined;

    if (!isNil(featureType)) {
      const feature = convertInfrastructureToFeature(ymaps, item, featureType);
      acc.push(feature);

      return acc;
    }

    return acc;
  }, [] as IInfrastructureObject[]);
}

export function createVillagePin(coordinates: [number, number], ymaps: YMaps.IYMaps) {
  return {
    geometry: {
      coordinates,
      type: 'Point',
    },
    id: 'currentVillage',
    options: {
      iconLayout: ymaps.templateLayoutFactory.createClass(IconCurrentVillage),
      iconOffset: [-23, -55],
      iconShape: {
        coordinates: [33, 23],
        radius: 23,
        type: 'Circle',
      },
      iconSize: [46, 55],
      zIndex: 10,
    },
    type: 'Feature',
  };
}
